<template>
  <div class="links text-light flex-column">
    <header>
      <img style="margin: 30px 0;" class="img" :src="require(`@/assets/focco.png`)" width="220">
      <div class="subtitle-4">Área dos Representantes</div>
    </header>
    <div class="flex-column align-center">
      <a v-for="(button, index) in buttons" :key="index" :href="button.href">
        <button class="btn-primary">ACESSO {{ index+1 }}</button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Links',
  data () {
    return {
      buttons: [
        { href: 'https://foccoweb.grupotopazio.com.br:8443/f3iConnect/app/login.faces' },
        { href: 'https://192.168.254.41:8443/f3iConnect/app/login.faces' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .links {
    .subtitle-4 {
      margin: 20px 0;
      opacity: .8;
      font-size: 16px;
    }
    .btn-primary {
      background: #C3C3C3;
      color: #3e3e3e;
      margin-top: 20px;
      min-width: 290px;
      min-height: 50px;
    }
  }
</style>